import { IResult } from '../../models/result-models';
import { ISession } from '../../models/pro-sites';
import {
    LOAD_SESSION_ERROR,
    LOAD_SESSION_SUCCESS,
    UPDATE_SESSION_SUCCESS,
    UPDATE_SESSION_ERROR,
} from './session-actions';

export const initialSessionState: IResult<ISession> = {
    ok: false,
    data: {
        userName: '',
        firstName: '',
        lastName: '',
        country: '',
        billingAccount: '',
        shippingAccount: '',
        primaryBrand: '',
        InsiteToken: '',
        subsite: '',
        title: '',
        buckets: [],
        siteNumber: 0,
        userBuckets: [],
        features: [],
        carts: { primary: [], saved: [] },
        selectedOboAccount: {
            accountNumber: '',
            billToAccount: '',
            shipToAccount: '',
        },
        account: '',
        catalog: 0,
        selectedBrand: '',
        isOrderOnBehalfOf: false,
        isAccountThirdParty: false,
        isSiteUpgraded: false,
        phoneNumber: '',
        proAuthority: '',
        agreements: [],
        compatibilityList: [],
    },
};

interface LoadSessionSuccessAction {
    type: 'LOAD_SESSION_SUCCESS';
    result: IResult<ISession>;
}

interface LoadSessionErrorAction {
    type: 'LOAD_SESSION_ERROR';
    result: any;
}

interface UpdateSessionSuccessAction {
    type: 'UPDATE_SESSION_SUCCESS';
    result: IResult<ISession>;
}

interface UpdateSessionErrorAction {
    type: 'UPDATE_SESSION_ERROR';
    result: any;
}

type KnownAction =
    | LoadSessionSuccessAction
    | LoadSessionErrorAction
    | UpdateSessionSuccessAction
    | UpdateSessionErrorAction;

export const sessionReducer = (
    state: IResult<ISession> | null | undefined = null,
    action: KnownAction
): IResult<ISession> | null => {
    switch (action.type) {
        case LOAD_SESSION_SUCCESS:
            return action.result;
        case LOAD_SESSION_ERROR:
            return { ok: false, message: action.result.message };
        case UPDATE_SESSION_SUCCESS:
            return action.result;
        case UPDATE_SESSION_ERROR:
            return { ok: false, message: action.result.message };
        default:
            return state;
    }
};
